// extracted by mini-css-extract-plugin
module.exports = {"emojiButton":"index-module--emoji-button--1doxB","index":"index-module--index--2UCCW","demo":"index-module--demo--3gsQr","code":"index-module--code--39ijX"};